// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.savingsaccount.TransactionsEntity

@OptIn(InternalKtorfitApi::class)
public class _RunReportServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : RunReportService {
  override suspend fun getTransactionReceipt(outputType: String, transactionId: String): Flow<TransactionsEntity> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "runreports/Savings Transaction Receipt")
        outputType?.let{ parameter("output-type", "$it") }
        transactionId?.let{ parameter("R_transactionId", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<TransactionsEntity>>(),)!! 
  }
}

public class _RunReportServiceProvider : ClassProvider<RunReportService> {
  override fun create(_ktorfit: Ktorfit): RunReportService = _RunReportServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createRunReportService(): RunReportService = _RunReportServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
